import type { IconData } from '@stacksjs/iconify-core'

export const bug: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\"><path d=\"M24 45c9.153 0 15.763-6.077 15.96-15.227Q40 28.023 40 26c0-2.023-.014-2.606-.04-3.773C39.764 13.077 33.154 7 24 7C14.848 7 8.237 13.077 8.04 22.227A175 175 0 0 0 8 26q0 2.024.04 3.773C8.236 38.923 14.847 45 24 45Z\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m16 3l2 4m14-4l-2 4m-6 14v24\"/><path d=\"M39.495 18c-4.394 1.616-9.66 2.5-15.495 2.5S12.898 19.616 8.504 18\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m40 21l5-2m-5 14l5 2m-5-8h5.5M8 21l-5-2m5 14l-5 2m5-8H2.5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bug
